import _ from "lodash";
import { IProductCharacteristic, ISpecification } from "../../entities/product/types";


export default class SpecificationFactory {

  /*
   * This method will pass through product characteristics and find all unique specifications.
   */
  private static readonly getUniqSpecifications = (productCharacteristics: IProductCharacteristic[]) : ISpecification[] => {
    const specifications: any[] = [];
    productCharacteristics.forEach((char: IProductCharacteristic) => {
      specifications.push(char.specificationItemCharacteristic.specificationItem);
    });
    return _.uniqBy(specifications, 'id');
  };

  /*
   * Returns all characteristics based on specification id.
   */
  private static readonly getSpecCharacteristics = (specId: any, productCharacteristics: any[]) => {
    return productCharacteristics.filter((char: any) => char.specificationItemCharacteristic.specificationItem.id === specId);
  };

  /*
   * Creates new array of specifications with all characteristics based od API response.
   */
  public static createFromProductCharacteristics(productCharacteristics: IProductCharacteristic[]): ISpecification[] {
    const uniqSpec: ISpecification[] = this.getUniqSpecifications(productCharacteristics);
    const specifications: any[] = [];
    uniqSpec.forEach((spec: ISpecification) => {
      const newSpec = { ...spec, characteristics: this.getSpecCharacteristics(spec.id, productCharacteristics) };
      specifications.push(newSpec);
    });
    return specifications;
  }

}
